import React from 'react';
import styled from 'styled-components';
import { Body5, Container, Page } from '@ui';
import BackArrowButton from '@ui/buttons/BackArrowButton';
import { DragDrop } from '@ui/DragAndDropUploader';
import { useCurrentUserToolsAvailable } from '@hooks/user/useCurrentUser';
import { AI_TOOLS } from '@constants';
import { useDispatch } from 'react-redux';
import { uploadFilesActions } from '@constants/actionTypes';
import { UploadFilesList } from './UploadFilesList';
import { ProgressOverlay } from '@ui/ProgressOverlay';
import { addFileDefaults } from '@utils/doc';

const FormWrapper = styled.div`
  input {
    border: 1px solid ${({ theme }) => theme.themeColors.border};
    color: ${({ theme }) => theme.themeColors.text};
    background-color: transparent;
    border-radius: 6px;
    width: 100%;
    padding: 8px;
  }

  select {
    border: 1px solid ${({ theme }) => theme.themeColors.border};
    color: ${({ theme }) => theme.themeColors.text};
    background-color: transparent;
    border-radius: 6px;
    width: 100%;
    padding: 8px;
    -webkit-appearance: auto !important;
  }

  textarea {
    border: 1px solid ${({ theme }) => theme.themeColors.border};
    color: ${({ theme }) => theme.themeColors.text};
    background-color: transparent;
    border-radius: 6px;
    min-height: 300px;
    width: 100%;
    padding: 16px;
  }
`;

function UploadingOverlay() {
  return <ProgressOverlay message="Uploading..." />;
}

export const FileUploader = ({ onGoBack, pageWidth, reupload }) => {
  const dispatch = useDispatch();

  const [isUploading, setIsUploading] = React.useState(false);
  const toolsAvailable = useCurrentUserToolsAvailable();
  const isExcelUploadToolAvailable = toolsAvailable.includes(AI_TOOLS.EXCEL_UPLOAD);
  const isMsDocUploadToolAvailable = toolsAvailable.includes(AI_TOOLS.MS_DOC_UPLOAD);
  const isPPTUploadToolAvailable = toolsAvailable.includes(AI_TOOLS.PPT_UPLOAD);
  const isTxtUploadToolAvailable = true;

  const handleAddFiles = (fileOrFiles) => {
    dispatch({
      type: uploadFilesActions.addFiles,
      payload: addFileDefaults(fileOrFiles),
    });
  };

  return (
    <Page width={pageWidth}>
      {isUploading && <UploadingOverlay />}
      <BackArrowButton onClick={onGoBack} />
      <Container>
        <FormWrapper>
          <Container top={40}>
            <h3>Upload Files</h3>
            <Container top={8}>
              <Body5>
                Drag and drop files. You can change the file name, assign a company, and assign document type for
                document organization.
              </Body5>
            </Container>
          </Container>
          <Container top={32}>
            <DragDrop
              onAddFiles={handleAddFiles}
              docx={isMsDocUploadToolAvailable}
              pptx={isPPTUploadToolAvailable}
              xls={isExcelUploadToolAvailable}
              txt={isTxtUploadToolAvailable}
              csv
            />
          </Container>
          <Container top={16}>
            <UploadFilesList reupload={reupload} isUploading={isUploading} setIsUploading={setIsUploading} />
          </Container>
        </FormWrapper>
      </Container>
    </Page>
  );
};
